import React from "react";
import "../style/debtDetails.css";

export const DebtPayOffDetails = (props) => {
  function calculateRemainingYearsAndMonths(maturityDate) {
    const currentDate = new Date();
    maturityDate = new Date(maturityDate);
    const differenceMs = maturityDate - currentDate;
    const millisecondsInYear = 1000 * 60 * 60 * 24 * 365.25;
    const millisecondsInMonth = millisecondsInYear / 12;
    const remainingYears = Math.floor(differenceMs / millisecondsInYear);
    const remainingMonths = Math.floor(
      (differenceMs % millisecondsInYear) / millisecondsInMonth
    );

    return formatRemainingYearsAndMonths(remainingYears, remainingMonths);
  }
  function formatRemainingYearsAndMonths(remainingYears, remainingMonths) {
    if (remainingYears === 0) {
      return `${remainingMonths} months`;
    } else if (remainingYears === 1 && remainingMonths === 0) {
      return `${remainingYears} year`;
    } else if (remainingYears === 1) {
      return `${remainingYears} year, ${remainingMonths} months`;
    } else if (remainingMonths === 0) {
      return `${remainingYears} years`;
    } else {
      return `${remainingYears} years, ${remainingMonths} months`;
    }
  }

  const detailsData = [
    {
      id: 1,
      name: "Debt Payoff End Date",
      time: props.data && calculateRemainingYearsAndMonths(props.data),
    },
  ];
  return (
    <div>
      {" "}
      <div className="cardHeadingDebt">Debt Payoff Date</div>
      <div className="listingContainer">
        <React.Fragment>
          {detailsData && detailsData.length > 0 ? (
            detailsData.map((item, index) => (
              <div
                key={index}
                className="list-row-no"
                style={{ marginTop: "5rem" }}
              >
                <div className="listname-dark">
                  <div>{item.name}</div>
                  <div style={{ color: "#26C0E2", fontWeight: "400" }}>
                    {item.time}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="nodata">No data to show</div>
          )}
        </React.Fragment>
      </div>
    </div>
  );
};
